import { CleaningMissionSortOrder, cleaningMissionSortOrders, DEFAULT_CLEANING_MISSION_SORT_ORDER } from '@silbo/core';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import useStoredValue from '../../../hooks/useStoredValue';

const isSortOrder = (value: unknown): value is CleaningMissionSortOrder =>
  cleaningMissionSortOrders.includes(value as CleaningMissionSortOrder);

const isUnitIdList = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

/** Le tri et le filtre par unités de l'agent, gardés sur l'appareil d'une connexion à l'autre. */
export const useCleaningPreferences = () => {
  const { user } = useAuthenticationContext();
  const userKey = user?.id ?? 'anonymous';

  const [sortOrder, setSortOrder] = useStoredValue<CleaningMissionSortOrder>(
    `cleaning.sort-order.${userKey}`,
    // Un ordre enregistré que l'application ne connaît plus retombe sur le défaut.
    DEFAULT_CLEANING_MISSION_SORT_ORDER,
    isSortOrder
  );
  const [unitIds, setUnitIds] = useStoredValue<string[]>(`cleaning.unit-filter.${userKey}`, [], isUnitIdList);

  return { sortOrder, setSortOrder, unitIds, setUnitIds };
};
